
import MaisDetalhes from "../../Components/Personagens/Detalhes";



function DetalhesDaPersonagem() {


    return (
        <>
            <div>

                <div>

                    <MaisDetalhes />

                </div>
            </div>
        </>
    );
}

export default DetalhesDaPersonagem;


